import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";

import { VerificationTokenContext } from "./context/VerificationTokenContext";

/**
 * Guard for the public verification frame (marco B). Reads the identity token from `/verify/:token`, holds it
 * in memory via context (never localStorage), and renders the public sub-router. Authorization is the link
 * token itself — this route lives outside `PrivateRoute`/`PublicRoute` by design (the only unauthenticated
 * frame).
 */
export function VerificationLinkRoute({ children }: { children: ReactNode }) {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return <Navigate to="/auth" replace />;
  }

  return <VerificationTokenContext.Provider value={token}>{children}</VerificationTokenContext.Provider>;
}
